import React, {useEffect, useState, useContext} from "react";
import styles from "./processCompareStatisticalView/ProcessCompareStatisticalView.module.scss";
import SelectBox from "../../../Componnets/SelectBox/SelectBox";
import Chart from "./processCompareStatisticalView/Chart";
import appContext from "../../../../context/appContext";
import Graph from "../processMap/Graph";

const ProcessCompareStatisticalView = () => {

    const context = useContext(appContext);
    const [mainData, setMainData] = useState([]);
    const [activeItem, setActiveItem] = useState({});
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [selectedView, setSelectedView] = useState(null);
    const [chartsData, setChartsData] = useState([]);
    const sidebarData = [
        {
            id: 1,
            title: "per Activities",
            charts: ["Average "]
        },
        {
            id: 2,
            title: "on Variant"
        },
        {
            id: 3,
            title: "per Cases",
            disabled: true
        },
    ];

    const handleActiveItem = (index) => {
        if (index === "per Activities") {
            setSelectedView("Duration");
        }
        if (!activeItem[index]) {
            setActiveItem(prevState => ({ [ index ]: !prevState[ index ] }))
        }
    }

    useEffect(() => {
        setActiveItem({[sidebarData[0].title]: true});
        handleOnClick("activity", "All Activities");
        handleOnClick("view", "Duration");
    }, []);

    const activitiesToCompare = context.handleDataChartCompare().nodes || [];
    const variantsToCompare = context.handleDataChartCompare().variants || [];

    useEffect(() => {
        if (activeItem["per Activities"]) {
            let activities = [];
            if (activitiesToCompare && activitiesToCompare.length > 0) {
                activities = activitiesToCompare.map(item => {
                    if (item.name !== "@@S" && item.name !== "@@E" && item.layer2) {
                        return item.name
                    }
                }).filter(item => item !== undefined);
            }
            setActivities(["All Activities", ...activities]);
        } else if (activeItem["on Variant"]) {
            if (variantsToCompare && variantsToCompare.length > 0) {
                const variantsId = variantsToCompare.map(item => {
                    if (item.comparison_variant) {
                        return item.id
                    } else return
                })
                setActivities(["All Variants", ...variantsId.filter(item => item !== false)]);
            }
        }
    }, [activitiesToCompare, variantsToCompare, activeItem])

    const handleOnClick = (param, option) => {
        if (param === "activity") {
            setSelectedActivity(option);
        } else if (param === "view") {
            setSelectedView(option)
        }
    }

    useEffect(() => {
        if (activeItem["per Activities"]) {
            if (activitiesToCompare.length > 0 && selectedView) {
                const data = activitiesToCompare.filter(item => {
                    if (item.name !== "@@S" && item.name !== "@@E") {
                        return item
                    }
                })
                const chartsData = data.map(item => {
                    if (item.layer2) {
                        if (selectedView === "Duration") {
                            return {
                                title: item.name,
                                type: "time",
                                scale: Math.max(item.layer1?.total_duration_sec, item.layer2?.total_duration_sec),
                                data: [
                                    {
                                        title: "Total Duration",
                                        mainLayerValue: item.layer1?.total_duration_sec,
                                        comparisonLayerValue: item.layer2.total_duration_sec,
                                        mainLayerLabel: item.layer1?.total_duration.value,
                                        comparisonLayerLabel: item.layer2.total_duration.value,
                                    },
                                    {
                                        title: "Average Duration",
                                        mainLayerValue: item.layer1?.avg_duration_sec,
                                        comparisonLayerValue: item.layer2.avg_duration_sec,
                                        mainLayerLabel: item.layer1?.avg_duration.value,
                                        comparisonLayerLabel: item.layer2.avg_duration.value,
                                    },
                                    {
                                        title: "Max Duration",
                                        mainLayerValue: item.layer1?.max_duration_sec,
                                        comparisonLayerValue: item.layer2.max_duration_sec,
                                        mainLayerLabel: item.layer1?.max_duration.value,
                                        comparisonLayerLabel: item.layer2.max_duration.value,
                                    },
                                    {
                                        title: "Min Duration",
                                        mainLayerValue: item.layer1?.min_duration_sec,
                                        comparisonLayerValue: item.layer2.min_duration_sec,
                                        mainLayerLabel: item.layer1?.min_duration.value,
                                        comparisonLayerLabel: item.layer2.min_duration.value,
                                    },
                                ]
                            }
                        } else if (selectedView === "Rework") {
                            return {
                                title: item.name,
                                data: [
                                    {
                                        title: "Loop",
                                        mainLayerValue: item.layer1?.loop.value,
                                        comparisonLayerValue: item.layer2.loop.value,
                                        mainLayerLabel: item.layer1?.loop.value,
                                        comparisonLayerLabel: item.layer2.loop.value,
                                    },
                                    {
                                        title: "Self-Loops",
                                        mainLayerValue: item.layer1?.self_loop.value,
                                        comparisonLayerValue: item.layer2.self_loop.value,
                                        mainLayerLabel: item.layer1?.self_loop.value,
                                        comparisonLayerLabel: item.layer2.self_loop.value,
                                    },
                                ]
                            }
                        } else if (selectedView === "Frequency") {
                            return {
                                title: item.name,
                                scale: Math.max(item.layer1?.total_frequency.value, item.layer2?.total_frequency.value),
                                data: [
                                    {
                                        title: "Total Count",
                                        mainLayerValue: item.layer1?.total_frequency.value,
                                        comparisonLayerValue: item.layer2.total_frequency.value,
                                        mainLayerLabel: item.layer1?.total_frequency.value,
                                        comparisonLayerLabel: item.layer2.total_frequency.value,
                                    },
                                    {
                                        title: "Case Count",
                                        mainLayerValue: item.layer1?.case_frequency.value,
                                        comparisonLayerValue: item.layer2.case_frequency.value,
                                        mainLayerLabel: item.layer1?.case_frequency.value,
                                        comparisonLayerLabel: item.layer2.case_frequency.value,
                                    },
                                ]
                            }
                        }
                    }
                })
                setMainData(chartsData.filter(item => item));
            }
        } else if (selectedActivity && activeItem["on Variant"]) {
            if (variantsToCompare.length > 0 && selectedView) {
                const chartsData = variantsToCompare.map(item => {
                    if (item.comparison_variant) {
                        return {
                            title: item.id,
                            data: [
                                {
                                    title: "Case Frequency",
                                    mainLayerValue: item.count,
                                    comparisonLayerValue: item.comparison_variant.count,
                                    mainLayerLabel: item.count,
                                    comparisonLayerLabel: item.comparison_variant.count,
                                },
                                {
                                    title: "AVG Event Frequency",
                                    mainLayerValue: item.comparison_variant.base_avg_duration,
                                    comparisonLayerValue: item.comparison_variant.layer_avg_duration,
                                    mainLayerLabel: item.comparison_variant.base_avg_duration,
                                    comparisonLayerLabel: item.comparison_variant.layer_avg_duration,
                                }
                            ]
                        }
                    } else return;
                })

                setMainData(chartsData.filter(item => item !== false));
            }
        }
    }, [selectedView, activeItem, activitiesToCompare, variantsToCompare, context.handleDataChartCompare()]);

    useEffect(() => {
        if (mainData && mainData.length > 0) {
            if (selectedActivity && selectedActivity !== "All Activities" && selectedActivity !== "All Variants") {
                const filterSelectedView = mainData.filter(item => item?.title === selectedActivity);
                setChartsData(filterSelectedView);
            } else if (selectedActivity && (selectedActivity === "All Activities" || selectedActivity === "All Variants")) {
                setChartsData(mainData);
            }
        }
    }, [selectedActivity, mainData]);

    useEffect(() => {
        setChartsData([]);
        if (activeItem["per Activities"]) {
            setSelectedActivity("All Activities");
            setSelectedView("Duration");
        } else if (activeItem["on Variant"]) {
            setSelectedActivity("All Variants");
        }
    }, [activeItem]);

    return (

       <>
           <Graph statisticalView type="statistical-view" notShowHandler/>
           <div className={styles.ProcessCompareStatisticalView}>
               <div className={styles.header}>
                   <h2>Statistical View</h2>
                   <h3>{ context.handleUid().name }</h3>
               </div>
               <div className={styles.contentWrapper}>
                   <div className={styles.sidebar}>
                       <ul>
                           {
                               sidebarData.map(item => (
                                   <li
                                       onClick={() => handleActiveItem(item.title)}
                                       className={
                                           `d-flex align-items-center justify-content-center 
                                           ${(activeItem[item.title] ? styles.active : '')} 
                                           ${(item.disabled && styles.disabled)}
                                       `}>
                                       <div className={`text-center ${styles.sidebarItem}`}>{ item.title.split(' ').map(i => <div>{ i }</div>) }</div>
                                   </li>
                               ))
                           }
                       </ul>
                   </div>
                   <div className={styles.content}>
                       <div className={`d-flex align-items-center justify-content-between ${styles.topBar}`}>
                           <div className={`d-flex ${styles.columnName}`}>
                               <div>{ Object.keys(activeItem).length > 0 && Object.keys(activeItem)[0].charAt(0).toUpperCase() + Object.keys(activeItem)[0].slice(1) }</div>
                               <div>
                                   <SelectBox
                                       dropDownValue={selectedActivity ? selectedActivity : 'Choose an Option'}
                                       boxStyle={'transparent'}
                                       optionsContainerWidth={200}
                                   >
                                       {
                                           activities.length > 0 && activities.map(option => (
                                               <div className={[styles.columnOptions, (option === selectedActivity && styles.isActive)].join(' ')} onClick={() => handleOnClick("activity", option)}>
                                                   <span>{option}</span>
                                               </div>
                                           ))
                                       }
                                   </SelectBox>
                               </div>
                           </div>
                           {
                               activeItem["per Activities"] &&
                               <div>
                                   <SelectBox
                                       dropDownValue={selectedView ? selectedView : 'Choose an Option'}
                                       boxStyle={'transparent'}
                                       style={{fontSize: 12, fontWeight: "normal"}}
                                       arrow={<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                           <path d="M12.6666 6.16663L7.99998 10.8333L3.33331 6.16663" stroke="#0A195C" stroke-linecap="round" stroke-linejoin="round"/>
                                       </svg>
                                       }
                                       optionsContainerWidth={100}
                                   >
                                       {
                                           ["Duration", "Rework", "Frequency"].map(option => (
                                               <div className={[styles.columnOptions, (option === selectedView && styles.isActive)].join(' ')} onClick={() => handleOnClick("view", option)}>
                                                   {option}
                                               </div>
                                           ))
                                       }
                                   </SelectBox>
                               </div>
                           }
                       </div>
                       <div className={styles.chartsWrapper}>
                           {
                               Object.keys(chartsData).length > 0 && chartsData.map(item =>
                                   item && (<>
                                       {
                                           chartsData.length > 1 &&
                                           <div className={styles.chartsTitleHeader}>{ item && item.title }</div>
                                       }
                                       <div>
                                           {
                                               item && item.data.length > 0 && item.data.map(chartData => (
                                                   <Chart
                                                       title={chartData.title}
                                                       mainLayerValue={chartData.mainLayerValue}
                                                       mainLayerLabel={chartData.mainLayerLabel}
                                                       comparisonLayerValue={chartData.comparisonLayerValue}
                                                       comparisonLayerLabel={chartData.comparisonLayerLabel}
                                                       comparisonLayerColor={context.handleCompareColor()}
                                                       type={item.type}
                                                       scale={item.scale || null}
                                                   />
                                               ))
                                           }
                                       </div>
                                   </>)
                               )
                           }
                       </div>
                   </div>
               </div>
           </div>
       </>

    )
}

export default ProcessCompareStatisticalView;